export const TOAST_EVENT_NAME = 'oap-toast-notification:open';
